import { isDataWorkerPlatformSupported } from "./isDataWorkerPlatformSupported";

export function isDataWorkerPlatformEnabled(): boolean {
    return isDataWorkerPlatformSupported();
}
